module.exports = __webpack_public_path__ + "img/red-1-diamond-open.6603189d.svg";